export function schoolTermEmployeeRelationshipListByEmployeeIdQuery(
  employeeId
) {
  return `{schoolTermEmployeeRelationshipListByEmployeeId(employeeId: ${
    employeeId || 0
  }){
    id
    active
    schoolTerm {
      id
      name
      year
      finalDate
      initialDate
      updaterId
    }
    employee {
      id
      name
      updaterId
      label
      value
      filterByStatus
    }
  }
}`;
}

export function schoolTermEmployeeRelationshipForLoggedUser() {
  const query = `{schoolTermEmployeeRelationshipForLoggedUser {id, active, schoolTerm{id, name, year, finalDate, initialDate}, employee{id, name}}}`;
  return query;
}

export function schoolTermEmployeeRelationshipListByTermIdQuery(termId) {
  const query = `{schoolTermEmployeeRelationshipListByTermId(termId: ${termId}){id, active, schoolTerm{id, name, year, finalDate, initialDate}, employee{id, name}}}`;
  return query;
}
